import styled from 'styled-components';

export const Wrapper = styled.div`
  .swiper-button-next,
  .swiper-button-prev {
    max-width: fit-content;
    padding: 20px;
    opacity: 0.6;
    border-radius: 30px;
    width: 36px;
    height: 36px;
    background-color: ${({ theme }) => theme.palette.darkGrey};
    display: flex;
    align-items: center;
    justify-content: center;
    ::after {
      font-size: 20px;
      color: ${({ theme }) => theme.palette.white};
      font-weight: 700;
    }
  }
  .swiper-pagination {
    position: inherit;
    bottom: 30px;
    z-index: 15;
    display: flex !important;
    justify-content: center;
    .swiper-pagination-bullet {
      margin-right: 10px;
      background: ${({ theme }) => theme.palette.darkGrey} !important;
      opacity: 0.6 !important;
      display: block;
      width: 12px;
      height: 12px;
      border: 2px solid ${({ theme }) => theme.palette.white};
      border-radius: 6px;
    }
    .swiper-pagination-bullet-active {
      opacity: 1 !important;
      width: 40px;
      height: 12px;
      background: ${({ theme }) => theme.palette.coral} !important;
    }
  }
`;
